import { render, staticRenderFns } from "./group_ans.vue?vue&type=template&id=39094c88&scoped=true&"
import script from "./group_ans.vue?vue&type=script&lang=js&"
export * from "./group_ans.vue?vue&type=script&lang=js&"
import style0 from "./group_ans.vue?vue&type=style&index=0&id=39094c88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39094c88",
  null
  
)

export default component.exports